import React, { useState } from 'react';
import { useDroppableHeaderContext } from '../droppableHeaderV2.hook';
import CloseGlyph from '../../../../assets/icons/Glyph/CloseGlyph';
import Popover from '../../../popover/popover';
import AlertGlyph from '../../../../assets/icons/Glyph/AlertGlyph';
import TextButton from '../../../button/textButton';
import { TypeOptions } from '../../../typo/STTypo.models';

type OptionsDeleteButtonProps = {
  onDelete: () => void;
};

export function DroppableHeaderOptionsDeleteButton({ onDelete }: OptionsDeleteButtonProps) {
  const { glyphColor, handleClickEvent } = useDroppableHeaderContext();
  return (
    <button
      type='button'
      className='unstyled-button mr-5 drag-header__button'
      onClick={e => handleClickEvent(e, onDelete)}
      aria-label='Remove button'>
      <CloseGlyph color={glyphColor} />
    </button>
  );
}

type OptionsDeleteWithPopoverButtonProps = OptionsDeleteButtonProps & {
  deletePopoverText: string;
};

export function DroppableHeaderOptionsDeleteWithPopoverButton({ onDelete, deletePopoverText }: OptionsDeleteWithPopoverButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { glyphColor } = useDroppableHeaderContext();

  return (
    <Popover
      content={
        <div className='mr-5 drag-header__popover'>
          <div className='mr-5 drag-header__popover__content'>
            <AlertGlyph />
            <span>{deletePopoverText}</span>
          </div>
          <div className='mr-5 drag-header__popover__footer'>
            <TextButton
              text='Cancel'
              type={TypeOptions.P1}
              ariaLabel='header cancel deletion'
              className='mr-5 drag-header__popover__footer__cancel'
              onClick={() => {
                setIsOpen(false);
              }}
            />
            <TextButton
              text='Remove'
              type={TypeOptions.P1}
              ariaLabel='Header remove'
              className='mr-5 drag-header__popover__footer__remove'
              onClick={() => {
                onDelete();
                setIsOpen(false);
              }}
            />
          </div>
        </div>
      }
      visible={isOpen}
      handleVisibleChange={setIsOpen}>
      <button
        type='button'
        className='unstyled-button mr-5 drag-header__button'
        onClick={e => e.stopPropagation()}
        aria-label='Remove button'>
        <CloseGlyph color={glyphColor} />
      </button>
    </Popover>
  );
}
